import { render, staticRenderFns } from "./MyDetail.vue?vue&type=template&id=384ebe78&scoped=true&"
import script from "./MyDetail.vue?vue&type=script&lang=js&"
export * from "./MyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyDetail.vue?vue&type=style&index=0&id=384ebe78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ebe78",
  null
  
)

export default component.exports